import Alpine from "alpinejs";
import Collapse from "@alpinejs/collapse";
import validate from "@colinaut/alpinejs-plugin-simple-validate";
import ScrollTrigger from "gsap/ScrollTrigger";

Alpine.plugin(Collapse);
Alpine.plugin(validate);

// Components
import { icons, injectSvgClasses } from "./icons";
import { heroBanner } from "./components/heroBanner";
import { footerParallax } from "./components/footerParallax";
import { ctaImageParallax } from "./components/ctaImageParallax";
import { smoothScroll } from "./components/smoothScroll";
import { stickyHeader } from "./components/stickyHeader";
import { textMaskReveal } from "./components/textMaskReveal";
import { scrollAnimations } from "./components/scrollAnimations";
import { initDraggableMarquee } from "./components/logoCloudMarquee";
import { initServiceCardReveal } from "./components/serviceCardReveal";
import { initIndustrySwiper } from "./components/industrySwiper";
import { projectListFilters, projectListWithLoadMore } from "./components/projectListFilters";
import { teamMemberList } from "./components/teamMemberList";
import { initTestimonialSlider } from "./components/testimonialSlider";
import { gsapHorizontalLoop } from "./components/footerCtaScroller";
import { initPageBannerAnimated } from "./components/pageBannerAnimated";
import { milestoneTimeline } from "./components/milestoneTimeline";
import { contactForm } from "./components/form";
// import { stackingCardsParallax } from "./components/stackingCardsParallax";

// Global
window.Alpine = Alpine;
window.icons = icons;
window.injectSvgClasses = injectSvgClasses;
window.heroBanner = heroBanner;
window.footerParallax = footerParallax;
window.ctaImageParallax = ctaImageParallax;
window.smoothScroll = smoothScroll;
window.stickyHeader = stickyHeader;
window.textMaskReveal = textMaskReveal;
window.scrollAnimations = scrollAnimations;
window.initDraggableMarquee = initDraggableMarquee;
window.projectListFilters = projectListFilters;
window.projectListWithLoadMore = projectListWithLoadMore;
window.teamMemberList = teamMemberList;
window.gsapHorizontalLoop = gsapHorizontalLoop;
window.milestoneTimeline = milestoneTimeline;
window.contactForm = contactForm;

// Inits
Alpine.start();

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  // Initialize Lenis Smooth Scroll first (before ScrollTrigger animations)
  smoothScroll.init();
  smoothScroll.initAnchorLinks();

  // Initialize Sticky Header (works with Lenis)
  stickyHeader.init();

  // Initialize Footer Parallax (works with Lenis)
  footerParallax.init();

  // Initialize CTA Image Parallax (works with Lenis)
  ctaImageParallax.init();

  // Initialize Text Mask Reveal (wait for fonts to load for accurate splitting)
  textMaskReveal.initWhenFontsReady();

  // Initialize Draggable Marquee (logo clouds)
  initDraggableMarquee();

  // Initialize Service Card Reveal (works with Lenis)
  initServiceCardReveal();

  // Initialize Industry Swiper (after DOM is ready)
  initIndustrySwiper();

  // Initialize Testimonial Slider (after DOM is ready)
  initTestimonialSlider();

  // Footer CTA uses Alpine + GSAP (footerCtaScroller), no init needed

  // Initialize Stacking Cards Parallax (list layout of core services)
  // stackingCardsParallax.init();

  // Initialize Scroll Animations (works with Lenis)
  scrollAnimations.init();

  // Initialize Animated Page Banner (GSAP Flip on Scroll)
  initPageBannerAnimated();

});

// Refresh ScrollTrigger after all images and resources load
// Handles layout shifts from late-loading images (especially in hero sections)
window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});
